/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { budgetsDeleteOrg } from "../../funcs/budgetsDeleteOrg.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteOrgBudgetRequest$inboundSchema,
};

export const tool$budgetsDeleteOrg: ToolDefinition<typeof args> = {
  name: "budgets-delete-org",
  description: `Delete an org budget

Removes the org's budget for the given owner; enforcement and alerts stop. Targets the caller's own organization (inferred from the API key or session) unless the optional org_id query parameter names another org — cluster admins only.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await budgetsDeleteOrg(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
